export const reactSmartScrollerId = 'react-smart-scroller'
